import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "@/shared/core-configs";
import { API } from "@/config";
import { GET_CLIENT_ENTITIES_FETCH_KEY } from "./useGetClientEntities";
import { ClientEntity } from "../types/ClientEntity";
import { ClientEntityFormInput } from "../components/CreateClientEntityModal";

export const updateClientEntity = async (
  id: string,
  updatedClientEntity: ClientEntityFormInput,
): Promise<ClientEntity> => {
  const response = await fetcher.put<ClientEntity>(
    `${API.GESLUB}/client-entities/${id}`,
    updatedClientEntity,
  );
  return response.data;
};

export const useUpdateClientEntity = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation<
    ClientEntity,
    Error,
    { id: string; updatedClientEntity: ClientEntityFormInput }
  >({
    mutationFn: async ({ id, updatedClientEntity }) => {
      return updateClientEntity(id, updatedClientEntity);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_CLIENT_ENTITIES_FETCH_KEY],
      });
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
};
